import * as React from "react";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
const SvgDevice = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 16 16",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M2.667 4h12V2.667h-12c-.734 0-1.334.6-1.334 1.333v7.333H0v2h9.333v-2H2.667V4zm12.666 1.333h-4c-.366 0-.666.3-.666.667v6.667c0 .366.3.666.666.666h4c.367 0 .667-.3.667-.666V6c0-.367-.3-.667-.667-.667zm-.666 6H12V6.667h2.667v4.666z",
		fillRule: "nonzero"
	})
});
export default SvgDevice;
